import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-comment-open-popup',
  templateUrl: './comment-open-popup.component.html',
  styleUrls: ['./comment-open-popup.component.scss']
})
export class CommentOpenPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
